import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from 'components/foundations/Icon';
import css from './FieldLabel.css';

const FieldLabel = ({ icon, translationKey, required = false }) => (
    <div className={css.fieldLabel}>
        <Icon name={icon} size={IconSizes.X_SMALL} variant={IconVariants.DARK} interactive={false} />
        <Translate id={translationKey} />
        {required && <span className={css.required}>*</span>}
    </div>
);

FieldLabel.propTypes = {
    icon: PropTypes.string.isRequired,
    translationKey: PropTypes.string.isRequired,
    required: PropTypes.bool,
};

export default FieldLabel;
